import React from "react";

import CloseIcon from "@uui/XClose";
import { isObject } from "lodash/fp";

import type { AlertProps } from "@mui/material";
import IconButton from "@mui/material/IconButton";

import { AlertBannerProps } from "@rui/AlertBanner/AlertBanner";
import { AlertBannerAction } from "@rui/AlertBanner/styles";
import { Row } from "@rui/Stack";

interface IAlertBannerAction {
  label: string;
  onClick: (event: React.MouseEvent) => void;
}

export interface AlertBannerActionsProps {
  severity: AlertProps["severity"];
  action: IAlertBannerAction | React.ReactNode;
  onClose?: AlertProps["onClose"];
}
const isActionObj = (
  action?: AlertBannerProps["action"]
): action is IAlertBannerAction => isObject(action) && "label" in action;

const AlertBannerActions = ({
  severity,
  action,
  onClose,
}: AlertBannerActionsProps) => {
  if (!action && !onClose) return null;

  return (
    <Row variant="center" spacing={1}>
      {React.isValidElement(action) ? (
        action
      ) : isActionObj(action) ? (
        <AlertBannerAction color={severity} onClick={action.onClick}>
          {action.label}
        </AlertBannerAction>
      ) : null}
      {onClose && (
        <IconButton onClick={onClose} size="small">
          <CloseIcon sx={{ color: "shades.neutral.500", fontSize: "18px" }} />
        </IconButton>
      )}
    </Row>
  );
};

export default AlertBannerActions;
